<!-- <form [formGroup]="form">
    <mat-form-field>
        <mat-label>{{label}}</mat-label>
        <textarea  matInput [placeholder]="placeholder" [value]="value" type="text" [id]="id" [style]="style"
            [formControlName]="controlName" [required]="required">
            </textarea>
        <mat-hint>{{hint}}</mat-hint>
        <mat-error>
            {{error_msg}}
        </mat-error>
    </mat-form-field>
</form> -->
<label *ngIf="label_block" class="m-0" class="input-label html-label" [ngClass]="{'req' : required }"
    [innerHtml]="label | HTMLFormatter"></label>
<mat-label *ngIf="!label_block" class="input-label text-nowrap" [ngClass]="{req : required }">
    <span [innerHtml]="label | HTMLFormatter"></span>
      <span *ngIf="verification_required" style="float: right;font-weight: bold;color: #000;">
        <i *ngIf="verified_status == 1" title="Verified" class="fa fa-check-circle-o"
          style="pointer-events:visible !important;color: green;" aria-hidden="true"></i>
        <i *ngIf="!verified_status || verified_status == 2" title="Not Verified" class="fa fa-times-circle-o" [ngClass]="{'pr-3':notes}"
          style="pointer-events:visible !important;color: red;" aria-hidden="true"></i>
        <i *ngIf="notes" [title]="notes?notes:''" style="pointer-events:visible !important;"
          class="fa fa-commenting-o pr-3"></i>
        <i *ngIf="reason && verified_status == 2" [title]="reason?reason:''" style="pointer-events:visible !important;"
          class="fa fa-info"></i>
      </span>
</mat-label>

<div class="form-group" style="box-shadow: 0 0 1px 1px #b3b3b3">
    <form [formGroup]="form">
        <!-- <ckeditor [formControlName]="controlName" [editor]="Editor" (ready)="onReady($event)" placeholder="Content"
            style="box-shadow: none !important;">
        </ckeditor> -->
        <angular-editor *ngIf="controlName" (contextmenu)="clickListner($event)" (change)="onChangeListner($event)"
            [formControlName]="controlName" [config]="editorConfig">
        </angular-editor>
    </form>
</div>